import type { KeyboardEvent } from "react";

/** Search and result arrows stay inside the picker, including when the graph has shortcuts. */
export function navigatePicker(event: KeyboardEvent, root: HTMLElement | null) {
  const target = event.target as HTMLElement;
  if (event.key === "Enter" && target.matches('input[type="checkbox"][data-picker-option]')) {
    event.preventDefault();
    event.stopPropagation();
    target.click();
    return;
  }
  if (event.key !== "ArrowDown" && event.key !== "ArrowUp") return;
  if (event.metaKey || event.ctrlKey || event.altKey || !root) return;
  const options = [...root.querySelectorAll<HTMLElement>("[data-picker-option]")];
  const index = options.indexOf(target);
  const search = root.querySelector<HTMLInputElement>('input[type="search"]');
  if (index < 0 && target !== search) return;
  event.preventDefault();
  event.stopPropagation();
  const next = index + (event.key === "ArrowDown" ? 1 : -1);
  if (next < 0) search?.focus();
  else options[next]?.focus();
}
